import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "lc_title_box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, null, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: _ctx.label
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: _ctx.data.sellist,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.data.sellist = $event),
        multiple: "",
        onChange: _ctx.changeSelEmit,
        placeholder: "请选择",
        style: {
          "width": "500px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selvallist, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.label + item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    }, 8, ["label"])]),
    _: 1
  })]);
}